// extracted by mini-css-extract-plugin
module.exports = {"autoComplete":"CD","error":"DD","disabled":"ED"};